function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoNonRiconciliabile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.79 54.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M38.5,5.16c-3.81-2.54-8.38-4.01-13.29-4.01C11.92,1.15,1.15,11.94,1.15,25.25s10.77,24.1,24.05,24.1c2.39,0,4.7-.35,6.88-1",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeWidth: "2.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.21,38.78c3.77-5.32,5.34-12.14,3.93-18.88",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeDasharray: "0 6.61",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.38,9.73c.87,1.1,1.65,2.27,2.33,3.54",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeDasharray: "0 9.9",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.38,9.73h0M47.4,17.16h0M40.41,42.97h0",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "31.57 53.52 34.03 47.08 27.63 44.61",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNonRiconciliabile);
export default __webpack_public_path__ + "static/media/ico-non-riconciliabile.130f7f138653ae188827b1e5a3cb60ce.svg";
export { ForwardRef as ReactComponent };